"use client";
import { jsx as o } from "react/jsx-runtime";
import { withCmsDataHandling as _ } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import b from "../../layout/Container/Container.js";
import { Image as j, sharedHandler as v } from "@ingeniorforeningen/figurine-core";
import { forwardRef as A } from "react";
import { pictureDeliveryApiParser as C } from "./Picture.helpers.js";
import '../../../assets/Picture.css';const z = "_root_1188o_2", D = {
  root: z
}, t = A((r, i) => {
  const {
    src: e,
    alt: a,
    title: s,
    placeholder: n,
    landscape: p,
    portrait: m,
    objectPosition: c,
    portraitObjectPosition: l,
    width: d,
    height: f,
    fit: h,
    caption: P,
    byline: u,
    captionAlign: y,
    shadow: w,
    polymorphicProps: g,
    orientation: x,
    ...N
  } = r;
  return /* @__PURE__ */ o(b, { ...N, size: "md", children: /* @__PURE__ */ o(
    j,
    {
      ref: i,
      className: D.root,
      src: e,
      alt: a,
      title: s,
      placeholder: n,
      landscape: p,
      portrait: m,
      objectPosition: c,
      portraitObjectPosition: l,
      width: d,
      height: f,
      fit: h,
      caption: P,
      byline: u,
      captionAlign: y,
      shadow: w,
      polymorphicProps: g,
      orientation: x,
      sizes: "(max-width: 48em) 95vw, 690px"
    }
  ) });
});
t.displayName = "Picture";
const H = _({
  Component: v(t),
  deliveryApiParser: C
});
H.displayName = t.displayName;
export {
  D as P,
  t as _Picture,
  H as default
};
